import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { TrophyIcon, MapPinIcon, StoreIcon, CalendarIcon } from 'lucide-react';
export function FounderProof() {
  return <section className="py-12 md:py-20 bg-dark-900 border-y border-gold-500/10 relative overflow-hidden" data-id="element-98">
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[400px] h-[400px] bg-gold-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-99" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-5xl mx-auto" data-id="element-101">
          <div className="text-center mb-6 md:mb-10" data-id="element-102">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-gold-500/30 bg-gold-500/10 text-gold-400 text-xs md:text-sm font-medium" data-id="element-103">
              <TrophyIcon size={14} data-id="element-104" /> Resultados del creador
            </div>
            <h2 className="text-2xl md:text-5xl font-display text-white uppercase tracking-wide leading-tight mt-3 md:mt-5" data-id="element-105">
              +80 mil USD facturados <br className="md:hidden" data-id="element-106" />
              <span className="text-gradient-gold" data-id="element-107">en 5 meses</span>
            </h2>
            <p className="text-sm md:text-lg text-gray-400 mt-2 md:mt-3 max-w-2xl mx-auto" data-id="element-108">
              100% en Argentina, con 5 tiendas funcionando. La misma metodología
              que aplicás vos.
            </p>
          </div>

          <div className="grid md:grid-cols-[1.5fr_1fr] gap-5 md:gap-8 items-center" data-id="element-109">
            {/* MercadoPago screenshot */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="relative bg-dark-800 rounded-xl md:rounded-2xl p-2 md:p-3 border border-gold-500/30 shadow-[0_0_40px_rgba(212,175,55,0.15)]" data-id="element-110">
              <div className="absolute -top-2.5 left-4 bg-gold-500 text-black font-display px-3 py-0.5 rounded-full text-[10px] md:text-xs tracking-widest uppercase shadow-lg" data-id="element-111">
                Mercado Pago
              </div>
              <div className="bg-white rounded-lg overflow-hidden" data-id="element-112">
                <img src="https://cdn.magicpatterns.com/uploads/4hrCnbC5m2mFfr85RLxPZG/Mercadopago_ganancia_5_meses.jpg" alt="Volumen de ventas en Mercado Pago: $111.615.051 en 5 meses" loading="lazy" decoding="async" width="700" height="950" className="w-full h-auto" data-id="element-113" />
              </div>
            </motion.div>

            {/* Stats grid */}
            <div className="grid grid-cols-2 md:grid-cols-1 gap-3 md:gap-4" data-id="element-114">
              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} className="bg-dark-800 rounded-xl p-4 md:p-5 border border-gold-500/20" data-id="element-115">
                <div className="flex items-center gap-2 text-gold-500 text-[10px] md:text-xs uppercase tracking-widest font-bold mb-1" data-id="element-116">
                  <TrophyIcon size={14} data-id="element-117" /> Volumen
                </div>
                <div className="text-xl md:text-3xl font-display text-white" data-id="element-118">
                  +80K USD
                </div>
                <div className="text-xs text-gray-400 mt-0.5" data-id="element-119">facturados</div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="bg-dark-800 rounded-xl p-4 md:p-5 border border-gold-500/20" data-id="element-120">
                <div className="flex items-center gap-2 text-gold-500 text-[10px] md:text-xs uppercase tracking-widest font-bold mb-1" data-id="element-121">
                  <CalendarIcon size={14} data-id="element-122" /> Período
                </div>
                <div className="text-xl md:text-3xl font-display text-white" data-id="element-123">
                  5 meses
                </div>
                <div className="text-xs text-gray-400 mt-0.5" data-id="element-124">2026</div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="bg-dark-800 rounded-xl p-4 md:p-5 border border-gold-500/20" data-id="element-125">
                <div className="flex items-center gap-2 text-gold-500 text-[10px] md:text-xs uppercase tracking-widest font-bold mb-1" data-id="element-126">
                  <StoreIcon size={14} data-id="element-127" /> Tiendas
                </div>
                <div className="text-xl md:text-3xl font-display text-white" data-id="element-128">
                  5 activas
                </div>
                <div className="text-xs text-gray-400 mt-0.5" data-id="element-129">
                  en simultáneo
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} className="bg-dark-800 rounded-xl p-4 md:p-5 border border-gold-500/20" data-id="element-130">
                <div className="flex items-center gap-2 text-gold-500 text-[10px] md:text-xs uppercase tracking-widest font-bold mb-1" data-id="element-131">
                  <MapPinIcon size={14} data-id="element-132" /> Mercado
                </div>
                <div className="text-xl md:text-3xl font-display text-white" data-id="element-133">
                  100% AR
                </div>
                <div className="text-xs text-gray-400 mt-0.5" data-id="element-134">Argentina</div>
              </motion.div>
            </div>
          </div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-center text-gray-400 italic text-sm md:text-base mt-6 md:mt-8 max-w-2xl mx-auto" data-id="element-135">
            "El mismo sistema que me llevó a mí a tener estos resultados,
            explicado sin humo y sin vueltas."
            <span className="block text-gold-500 not-italic font-bold mt-1 text-xs md:text-sm uppercase tracking-widest" data-id="element-136">
              — @nicoquarone
            </span>
          </motion.p>
        </motion.div>
      </div>
    </section>;
}